import { render, staticRenderFns } from "./DetailStoreShippingComponent.vue?vue&type=template&id=727c1aee&scoped=true&"
import script from "./DetailStoreShippingComponent.vue?vue&type=script&lang=js&"
export * from "./DetailStoreShippingComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailStoreShippingComponent.vue?vue&type=style&index=0&id=727c1aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727c1aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDivider,VIcon,VSpacer,VToolbar,VToolbarTitle})
